import Modal from '~/ui/components/common/Modal';
import ApplyCode from './ApplyCode';

import { ICarePlanIcd10Code } from '~/services/api/carePlanIcd10Codes/types';
import styles from './Icd10CodeModal.module.scss';

interface IProps {
  mode?: 'create' | 'edit';
  patientId: number;
  currentEditCarePlanIcd10Code?: ICarePlanIcd10Code;
  applyCodeInitialValues: ICarePlanIcd10Code;
  onClose: () => void;
  onCarePlanChange: () => void;
}

const Icd10CodeModal = ({
  mode = 'create',
  patientId,
  currentEditCarePlanIcd10Code,
  applyCodeInitialValues,
  onClose,
  onCarePlanChange,
}: IProps) => {
  const title = mode === 'create' ? 'Add Diagnosis (ICD-10)' : 'Update Diagnosis (ICD-10)';

  return (
    <Modal open maxWidth="sm" title={title} className={styles.modal} onClose={onClose}>
      <div className={styles.inner}>
        <div className={styles.heightSpacer} />

        <ApplyCode
          mode={mode}
          patientId={patientId}
          currentEditCarePlanIcd10Code={currentEditCarePlanIcd10Code}
          initialValues={applyCodeInitialValues}
          onClose={onClose}
          onCarePlanChange={onCarePlanChange}
        />
      </div>
    </Modal>
  );
};

export default Icd10CodeModal;
